"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Selects = require("../Selects");

var _TabsModule = _interopRequireDefault(require("./Tabs.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tabs = function Tabs(_ref) {
  var className = _ref.className,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      defaultSelectedIndex = _ref.defaultSelectedIndex,
      props = _objectWithoutProperties(_ref, ["className", "classes", "defaultSelectedIndex"]);

  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_TabsModule.default.tabs, className)
  }, _react.default.createElement(_Selects.BaseSelect, _extends({
    stateReducer: _Selects.toggleSingle,
    className: (0, _classnames.default)(_TabsModule.default.tab, classes.tab),
    selectedClassName: (0, _classnames.default)(_TabsModule.default.selected, classes.selectedTab),
    disabledClassName: (0, _classnames.default)(_TabsModule.default.disabled, classes.disabledTab)
  }, props, {
    defaultSelectedIndexes: defaultSelectedIndex && [defaultSelectedIndex]
  })));
};

process.env.NODE_ENV !== "production" ? Tabs.propTypes = {
  className: _propTypes.default.string
} : void 0;
Tabs.defaultProps = {
  className: ''
};
var _default = Tabs;
exports.default = _default;